export default __webpack_public_path__ + "static/media/Ñ.ac0bc417.png";